
import { Windmill, CaretUp} from "@phosphor-icons/react";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';


class customControls {
	constructor(opt) {
		let ctrl = this;
		ctrl.draw = opt.draw;
		ctrl.buttons = opt.buttons || [];
	}
	onAdd(map) {
		let ctrl = this;
		this.map = map;


		var elDiv = document.createElement('div');
		elDiv.className = 'mapboxgl-ctrl-group mapboxgl-ctrl first';

		this.setSiblingClickHandler();

		ctrl.elContainer = elDiv;
		ctrl.buttons.forEach((b) => {
			if(!b.id)
				ctrl.addSeparator();
			else {
				if(b.sub) {
					ctrl.addWrapper(b);
					ctrl.addButton(b, b.elWrapper);
					b.sub.forEach((bs) => {
						ctrl.addButton(bs, b.subMenu);
					});

				}
				else
					ctrl.addButton(b);
			}
		});


		return ctrl.elContainer;
	}
	onRemove(map) {
		let ctrl = this;
		ctrl.buttons.forEach((b) => {
			ctrl.removeButton(b);
		});
	}
	addSeparator(){
		var sep = document.createElement('div');
		sep.className = 'separator';
		this.elContainer.prepend(sep);
	}

	addWrapper(opt){
		var cont = document.createElement('div');
		cont.className = "sub-menu";
		var sep = document.createElement('div');
		sep.className = 'menu_wrp';

		var handle = document.createElement('div');
		handle.className = 'menu_handler';
		createRoot(handle).render(<CaretUp size={8} />);



		sep.prepend(cont);
		sep.append(handle);

		handle.addEventListener('click', (e)=>{

			e.stopPropagation();
			var p = e.target.closest(".menu_wrp");

			if(p.classList.contains("disabled"))
				return;
			p.classList.toggle("open");
		});
		document.addEventListener('click', (e)=>{sep.classList.remove("active")});

		this.elContainer.prepend(sep);
		opt.elWrapper = sep;
		opt.subMenu = cont;
	}
	addButton(opt, parent) {
		let ctrl = this;
		var elButton = document.createElement('button');

		if(opt.icon){
			if(typeof opt.icon  === 'string')
				elButton.innerHTML = opt.icon+'<span>'+opt.title+'</span>';
			else
				createRoot(elButton).render(
					!!parent && parent.className == 'sub-menu' ?
						<div>
							{opt.icon}
							<span>{opt.title}</span>
						</div>
					:
						<OverlayTrigger
							placement="top"
							delay={{ show: 50, hide: 200 }}
							overlay={<Tooltip id="button-tooltip">{opt.title}</Tooltip>}
						>
							{opt.icon}
						</OverlayTrigger>
				);
		}
		elButton.className = '';
		elButton.id = opt.id;
		if (opt.classes instanceof Array) {
			opt.classes.forEach((c) => {
				elButton.classList.add(c);
			});
		}
		//exit any othey function enbabled by another control
		//elButton.addEventListener('click', ctrl.exitMode.bind(this));
		if(opt.action && opt.on)
			elButton.addEventListener(opt.on, opt.action);

		if(opt.key){
			document.body.addEventListener("keyup", (e)=>{
				if(e.key === opt.key && e.ctrlKey) {
					e.preventDefault();
					e.stopPropagation();
					opt.action(e);
				}
			});
		}
		//elButton.title = opt.title;
		if(parent){
			elButton.addEventListener("click", (e)=>{
				this.placeIcon(e, opt);
				var p = e.target.closest(".menu_wrp");
				p.classList.remove("open");
			});

			parent.prepend(elButton);
		}
		else
			ctrl.elContainer.prepend(elButton);
		opt.elButton = elButton;
	}
	removeButton(opt) {
		opt.elButton.removeEventListener(opt.on, opt.action);
		opt.elButton.remove();
	}
	getButton(id){

		var ret = [];

		this.buttons.forEach((b)=>{

			if(b.id == id)
				ret.push(b);

			if(b.sub){
				b.sub.forEach((sb)=>{
					if(sb.id == id)
						ret.push(sb);
				});
			}

		})
		return ret;
	}
	placeIcon = (e, opt)=>{
		var b = e.target.closest("button");

		if(b.parentNode.classList.contains("menu_wrp"))
			return;

		var bc = b.cloneNode(true);
		if(opt.action && opt.on)
			bc.addEventListener(opt.on, opt.action);

		var sm = e.target.closest(".sub-menu");


		sm.previousSibling.remove();

		sm.parentNode.insertBefore(bc, sm);

	}
	enable(id){
		var self = this;

		if(id && !Array.isArray(id))
			id = [id];
		else if(!id)
			return this.setStatus(id, 'remove');

		id.forEach((a)=>{
			self.setStatus(a, 'remove');
		});
	}
	disable(id){
		var self = this;
		if(id && !(id instanceof Array))
			id = [id];
		else if(!id)
			return this.setStatus(id, 'add');

		id.forEach((a)=>{
			self.setStatus(a, 'add');
		});
	}
	setStatus(id, status){
		if(id){
			this.getButton(id).forEach((b)=>{
				b.elButton.classList[status]('disabled');
			});

			this.getButton(id).forEach((b)=>{
				b?.elWrapper?.classList[status]('disabled');
			});
		}
		else {
			this.buttons.forEach((b) => {
				if(b.elButton){
					b.elButton.classList[status]('disabled');
					b?.elWrapper?.classList[status]('disabled');
				}
			});
		}
	}
	exitMode(){
		const event = new KeyboardEvent("keyup",{
			'keyCode': 27
		});
		this.map.fire("keyup", event);
	}
	setSiblingClickHandler(){

		var self = this;
		var otherButtons = document.getElementsByClassName("mapbox-gl-draw_ctrl-draw-btn");
		for (let elButton of otherButtons) {
			elButton.addEventListener('mousedown', ()=>{self.exitMode();});
		};
	}
}
export default customControls
